import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import routes from '../../routes'
import SignIn from './In'
import SignPasswordForgot from './PasswordForgot'
import SignPasswordReset from './PasswordReset'
import SignUp from './Up'

const RedirectToSignIn = () => {
  return (
    <Redirect
      to={{
        pathname: routes.sign.route.reverse({ action: 'in' })
      }}
    />
  )
}

const SignRouter = () => {
  return (
    <Switch>
      <Route path={routes.sign.route.reverse({ action: 'in' })} component={SignIn} />
      <Route path={routes.sign.route.reverse({ action: 'up' })} component={SignUp} />
      <Route path={routes.sign.route.reverse({ action: 'partner' })} component={RedirectToSignIn} />
      <Route
        path={routes.sign.route.reverse({ action: 'password-forgot' })}
        component={SignPasswordForgot}
      />
      <Route
        path={routes.sign.route.reverse({ action: 'password-reset' })}
        component={SignPasswordReset}
      />
    </Switch>
  )
}

export default SignRouter
